<template>
  <div>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="listData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @on-load="loadData"
    >
      <template slot="examInfo" slot-scope="{ row }">
        <el-link type="primary" @click="showHealthItems(row)">{{ row.examInfo }}</el-link>
      </template>
      <template slot="dateRangeSearch">
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 100%"
        >
        </el-date-picker>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      title="体检项目"
      width="60%"
      :visible.sync="isDialogShow"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <avue-crud v-if="isDialogShow" :option="healthItemOption" :data="healthItems"> </avue-crud>
    </el-dialog>
  </div>
</template>
<script>
import {
  getIntegratedMachineDetectionList,
  getIntegratedMachineDetectionDetail,
} from '@/api/nursingHome/artificalDevice';

export default {
  props: ['row'],
  data() {
    return {
      isDialogShow: false, // 弹框是否显示着
      healthItems: [], // 体检项目
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      listData: [], // 列表数据
      loading: false,
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 数据的表格展示配置项
      tableOption: {
        border: true,
        index: true,
        columnBtn: false,
        refreshBtn: false,
        searchShowBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        searchMenuSpan: 6,
        labelWidth: 100,
        column: [
          {
            label: '用户编号',
            prop: 'memberCardNo',
          },
          {
            label: '姓名',
            prop: 'name',
            minWidth: 80,
          },
          {
            label: '性别',
            prop: 'sex',
            width: 60,
          },
          {
            label: '身份证号',
            prop: 'idCard',
            width: 140,
          },
          {
            label: '手机号',
            prop: 'mobile',
            width: 100,
            search: true,
          },
          {
            label: '检测情况',
            prop: 'examInfo',
            minWidth: 120,
            slot: true,
          },
          {
            label: '检测时间',
            prop: 'examTime',
            width: 140,
          },
          {
            label: '上传状态',
            prop: 'uploadStatus',
            width: 100,
          },
          {
            label: '检测日期',
            prop: 'dateRange',
            display: false,
            showColumn: false,
            search: true,
            searchslot: true,
            searchSpan: 12,
          },
        ],
      },
      // 体检项目配置项
      healthItemOption: {
        border: true,
        index: true,
        columnBtn: false,
        refreshBtn: false,
        searchShowBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '项目大类',
            prop: 'examItem',
          },
          {
            label: '项目名称',
            prop: 'examName',
          },
          {
            label: '检查结果',
            prop: 'checkResult',
          },
          {
            label: '参考值',
            prop: 'referenceValue',
          },
          {
            label: '状态',
            prop: 'checkStatus',
          },
        ],
      },
    };
  },
  methods: {
    loadData(page) {
      page = page || this.tablePage;
      this.loading = true;
      getIntegratedMachineDetectionList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize, deviceId: this.row.id },
          this.searchForm
        )
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.listData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {};
      this.dateRange = [];
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.dealDateRange();
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.examDateStart = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD 00:00:00');
        this.searchForm.examDateEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        this.searchForm.examDateStart = '';
        this.searchForm.examDateEnd = '';
        this.dateRange = [];
      }
    },
    showHealthItems(row) {
      this.healthItems = [];
      this.isDialogShow = true;
      getIntegratedMachineDetectionDetail({ elderlyId: row.id }).then(({ data }) => {
        this.healthItems = data;
      });
    },
  },
};
</script>
<style scoped>
/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
